import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useImmer } from 'use-immer';
import styled, { css } from 'styled-components';

import UpArrowIcon from 'assets/chevron-up.svg';
import Image from 'components/common/ImageLoader';

const FloatingUpBtn = styled.div`
  position: fixed;
  right: 2%;
  bottom: 7%;

  ${(props) =>
    props.makeVisible === true
      ? css`
          opacity: 1;
          z-index: 1;
        `
      : css`
          opacity: 0;
          z-index: 1;
        `};
`;

const FloatingUpArrowBtn = (props) => {
  const [state, setState] = useImmer({ verticalScrollTrigger: false });

  useEffect(() => {
    window.addEventListener('scroll', handleScrollVerticalMovement);
    return () => {
      window.removeEventListener('scroll', handleScrollVerticalMovement);
    };
  }, []);

  const handleScrollVerticalMovement = (evt) => {
    !state.verticalScrollTrigger &&
      setState((draft) => {
        draft.verticalScrollTrigger = true;
      });

    if (window.scrollY === 0) {
      setState((draft) => {
        draft.verticalScrollTrigger = false;
      });
    }
  };

  return (
    <FloatingUpBtn
      makeVisible={state.verticalScrollTrigger}
      className="p-2 transition duration-500 ease-in-out border-2 border-gray-500 bg-gray-300 cursor-pointer shadow-md hover:shadow-xl rounded-full 
      w-10 h-10 sm:w-16 sm:h-16 
      flex items-center justify-center"
      onClick={(e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
    >
      <Image width={30} height={30} src={UpArrowIcon} alt="team" />
    </FloatingUpBtn>
  );
};

export default FloatingUpArrowBtn;
